import { loginComponent } from './login.component';

export const loginStateName = 'app.login';

export const loginState = ($stateProvider) => {
  'ngInject';
  /**
   * This is the login state.  It is activated when the user navigates to /login, or if a unauthenticated
   * user attempts to access a protected state (or substate) which requires authentication. (see routerhooks/requiresAuth.js)
   *
   * It shows a login dialog and prompts the user to authenticate.  Once the user authenticates, it then
   * reactivates the state that the user originally came from.
   */
  $stateProvider.state({
    name: loginStateName,
    url: '/login?accessToken?jwt?error',
    params: {
      // access token is used for users coming from controlpanel
      accessToken: null,
      // jwt is injected per redirect from new keycloak impl
      jwt: null,
      error: null,
    },
    component: loginComponent.name,
    resolve: { returnTo, navigateHome },
  });
};

function navigateHome(userService, $state, $q) {
  'ngInject';
  let deferred = $q.defer();
  if (userService.isSignedIn()) {
    deferred.reject();
    $state.go('app.home');
  } else {
    deferred.resolve();
  }
  return deferred.promise;
}

/**
 * A resolve function which figures out what state we should return to after a successful login.
 *
 * If the user was redirected to this state (due to the requiresAuth redirect), then return the toState/params
 * they were redirected from.  Otherwise, if they transitioned directly, return the fromState/params.  Otherwise
 * return the main "app" state.
 */
function returnTo($transition$) {
  // Get the previous Transition, or null if this Transition is not the result of a redirection
  let redirectedFrom = $transition$.redirectedFrom();

  // The user was redirected to the login state (via the requiresAuth hook)
  if (redirectedFrom != null) {
    // Follow the current transition's redirect chain all the way back to the original attempted transition
    while (redirectedFrom.redirectedFrom()) {
      redirectedFrom = redirectedFrom.redirectedFrom();
    }

    // return to the original attempted "to state"
    return { state: redirectedFrom.to(), params: redirectedFrom.params('to') };
  }

  // The user was not redirected to the login state; they directly activated the login state somehow.
  // Return them to the state they came from.
  let fromState = $transition$.from();
  let fromParams = $transition$.params('from');
  if (fromState.name !== '') {
    return { state: fromState, params: fromParams };
  }

  // If the fromState's name is empty, then this was the initial transition.
  // Just return them to the home state.
  return { state: 'app.home' };
}
